import React from "react";
import { Routes, Route } from "react-router-dom";
import EditPrivacyPolicy from "./edit-privacy-policy";
import PrivacyPolicyDetail from "./privacy-policy-detail";

//
const PrivacyPolicy = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route path="" element={<PrivacyPolicyDetail />} />
         <Route path="/" element={<PrivacyPolicyDetail />} />
         <Route path="/edit" element={<EditPrivacyPolicy />} />
      </Routes>
    </React.Fragment>
  );
};

export default PrivacyPolicy;
